import ElementPlus from 'element-plus' //全局引入Element
import {ElMessage} from 'element-plus';
import 'element-plus/dist/index.css'
import zhCn from "element-plus/es/locale/lang/zh-cn"; // 引入中文语言包

export default {
    loadElementUi: (app) => {
        // elementUi使用中文
        app.use(ElementPlus, {locale: zhCn});
        // 注册一个全局的$message方法
        app.config.globalProperties.$message = ElMessage;
    }
}
